module.exports = __webpack_public_path__ + "img/vertical_6_1_6000.f9517e99.png";